import React, { useContext } from 'react';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import { ButtonIcon, ButtonText } from '@prisjakt/ui/button';
import { StoreLink, LinkDesktop, LinkMobile } from './styles';

export const GoToStoreButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { t } = useContext(AppContext);

  return (
    <StoreLink data-test="GoToStoreButton">
      <LinkDesktop ariaLabel={t('product', 'store.link')} tabIndex={-1}>
        <ButtonText>{t('product', 'store.link')}</ButtonText>
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </LinkDesktop>
      <LinkMobile>
        <IconChevronRight color="maybeBlue500" size={24} />
      </LinkMobile>
    </StoreLink>
  );
};
